<template>
    <!-- 对话框 -->
    <el-drawer
        title="订单信息"
        :visible.sync="show"
        :before-close="closeDialog"
        size="80%"
        @opened="openDrawer"
        class="order-detial-wrap"
        :show-close="false"
    >
        <div v-loading="loading" class="view-nth">
            <div class="steps" v-if="!loading">
                <!-- 根据接口返回数据显示步骤条 -->
                <el-steps :active="activeNum" align-center>
                    <el-step v-for="(item, i) in progress_bar" :key="i" :title="item.fieldName" :description="item.time"> </el-step>
                </el-steps>

                <!-- <el-steps :active="Number(stepsNum)" align-center>
                    <el-step title="新单" :description="order_details_time.order_time.YmdHis"></el-step>

                    <el-step v-if="order_status == 10" title="已取消" :description="order_details_time.end_time.YmdHis"></el-step>
                    <el-step title="已派单" :description="order_details_time.assign_time.YmdHis"></el-step>
                    <el-step title="已接单" :description="order_details_time.take_time.YmdHis"></el-step>
                    <el-step title="前往预约地" :description="order_details_time.go_way_time.YmdHis"></el-step>
                    <el-step title="到达预约地" :description="order_details_time.arrive_time.YmdHis"></el-step>
                    <el-step title="前往目的地" :description="order_details_time.start_time.YmdHis"></el-step>
                    <el-step v-if="order_status != 10" title="到达目的地" :description="order_details_time.end_time.YmdHis"></el-step>
                    <el-step v-if="order_status == 10" title="到达目的地" description="未设置"></el-step>
                    <el-step title="已结算" :description="order_details_time.pay_time.YmdHis"></el-step>
                </el-steps> -->
            </div>

            <div class="box">
                <div id="container_route" style="display: flex; justify-content: center; align-items: center"></div>

                <div v-if="!loading" class="tabs-box">
                    <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs" type="card">
                        <el-tab-pane label="订单信息" name="order">
                            <div style="height: 100%; overflow-y: auto">
                                <table style="width: 100%" class="primary-table">
                                    <tr class="head">
                                        <td>类型</td>
                                        <td>值</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>订单编号</td>
                                        <td>{{ order_details.billno }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>系统编号</td>
                                        <td>{{ search_data_children.order_code }}</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>司机电话</td>
                                        <td>{{ order_details.driver_phone }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>司机姓名</td>
                                        <td>{{ order_details.driver_real_name }}</td>
                                    </tr>
                                    <tr class="Odd" v-if="order_details.order_time">
                                        <td>下单时间</td>
                                        <td>{{ order_details.order_time.YmdHis }}</td>
                                    </tr>
                                    <tr class="even" v-if="order_details.order_mode">
                                        <td>订单模式</td>
                                        <td>{{ order_details.order_mode.name }}</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>出发地点</td>
                                        <td>{{ order_details.start_name }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>目的地</td>
                                        <td>{{ order_details.order_end_name }}</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>完成目的地</td>
                                        <td>{{ order_details.end_name }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>预约时间</td>
                                        <td>
                                            {{
                                                order_details.order_type.val == 1
                                                    ? order_details.reservation_order.YmdHis
                                                    : order_details.order_type.alias
                                            }}
                                        </td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>支付方式</td>
                                        <td>{{ order_details.pay_mode.alias }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>支付通道</td>
                                        <td>{{ order_details.pay_channel.alias }}</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>支付时间</td>
                                        <td>{{ order_details.pay_time.YmdHis }}</td>
                                    </tr>
                                    <tr class="even" v-if="showConsumer">
                                        <td>客户姓名</td>
                                        <td>{{ order_details.consumer_name }}</td>
                                    </tr>
                                    <tr class="Odd" v-if="showConsumer">
                                        <td>客户电话</td>
                                        <td>{{ order_details.consumer_phone }}</td>
                                    </tr>

                                    <tr class="even">
                                        <td>订单备注</td>
                                        <td>{{ order_details.remarks }}</td>
                                    </tr>
                                    <tr class="Odd" v-if="order_details.admin_code">
                                        <td>客服编码</td>
                                        <td>{{ order_details.admin_code }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>客服名称</td>
                                        <td>{{ order_details.admin_name }}</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>订单时长</td>
                                        <td>{{ getTimes(order_details.pay_time.YmdHis, order_details.order_time.YmdHis) }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>车牌号</td>
                                        <td>{{ order_details.plate }}</td>
                                    </tr>

                                    <tr class="even">
                                        <td>录音（保留4个月）</td>
                                        <td>
                                            <div style="width: 100%" v-for="(item, index) in recording">
                                                <audio :src="item" id="audio" controls>您的浏览器不支持 audio 标签。</audio>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="Odd">
                                        <td>开始拍照</td>
                                        <td>
                                            <div style="display: block" v-for="(item, index) in order_start_img">
                                                <el-image
                                                    style="width: 100px; height: 100px"
                                                    :src="item"
                                                    :preview-src-list="order_start_img"
                                                >
                                                </el-image>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="even">
                                        <td>结束拍照</td>
                                        <td>
                                            <div style="display: block" v-for="(item, index) in order_end_img">
                                                <el-image style="width: 100px; height: 100px" :src="item" :preview-src-list="order_end_img">
                                                </el-image>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="Odd">
                                        <td>司机自拍</td>
                                        <td>
                                            <el-image
                                                v-if="driver_img != ''"
                                                style="width: 100px; height: 100px"
                                                :src="driver_img"
                                                :preview-src-list="driver_img_pre"
                                            >
                                            </el-image>
                                        </td>
                                    </tr>
                                    <tr class="even">
                                        <td>取送车验证码</td>
                                        <td>{{ get_car_phone }}</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>余额验证码</td>
                                        <td>{{ wallet_msg }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>送车人姓名</td>
                                        <td>{{ send_name }}</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>送车人电话</td>
                                        <td>{{ send_phone }}</td>
                                    </tr>

                                    <tr class="even">
                                        <td>取车人电话</td>
                                        <td>{{ get_phone }}</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>车架号</td>
                                        <td>{{ vin_no }}</td>
                                    </tr>
                                    <!-- <tr class="even">
                    <td>取车人姓名</td>
                    <td>{{get_name}}</td>
                  </tr> -->
                                    <tr class="even">
                                        <td>接单时间(分钟)</td>
                                        <td>{{ assign }}</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>前往用时(分钟)</td>
                                        <td>{{ arrive }}</td>
                                    </tr>
                                </table>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane label="付款信息" name="payment">
                            <p v-if="order_synchronization == null" style="font-size: 16px; text-align: center; margin-top: 20px">
                                暂无付款信息
                            </p>

                            <div style="max-height: 100%; overflow-y: auto" v-else>
                                <table style="width: 100%" class="primary-table">
                                    <tr class="head">
                                        <td width="240px">款项名</td>
                                        <td>金额</td>
                                    </tr>
                                    <!-- 总费用 -->
                                    <tr class="even" v-if="order_synchronization.finish_amount">
                                        <td>{{ order_synchronization.finish_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.finish_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 附加服务费 -->
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.additional_services_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.additional_services_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 垫付费用 -->
                                    <tr class="even">
                                        <td>{{ order_synchronization.advance_payment_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.advance_payment_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 订单金额 -->
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.amount.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <tr class="Odd">
                                        <!-- 会员日优惠金额 -->
                                        <td>会员日优惠金额</td>
                                        <td>
                                            <span style="color: #f90">{{ menderDay_discountAmount }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 超远距离附加费用 -->
                                    <tr class="even">
                                        <td>{{ order_synchronization.far_area_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.far_area_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>

                                    <!-- 起步价 -->
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.starting_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.starting_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>

                                    <!-- 等待费用 -->
                                    <tr class="even">
                                        <td>{{ order_synchronization.wait_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.wait_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>

                                    <!-- 等待耗时 -->
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.wait_duration.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ Math.ceil(order_synchronization.wait_duration.val / 60) }}</span
                                            >分
                                        </td>
                                    </tr>

                                    <!-- 额外距离费用 -->
                                    <tr class="even">
                                        <td>{{ order_synchronization.distance_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.distance_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 额外耗时费用 -->
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.duration_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.duration_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 优惠费用 -->
                                    <tr class="even">
                                        <td>{{ order_synchronization.preferential_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.preferential_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 模式优惠 -->
                                    <tr class="Odd" v-if="order_synchronization.coupon_name">
                                        <td>{{ order_synchronization.limited_time_offer.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.limited_time_offer.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 优惠劵名称 -->
                                    <tr class="even" v-if="order_synchronization.coupon_name">
                                        <td>{{ order_synchronization.coupon_name.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.coupon_name.val }}</span>
                                        </td>
                                    </tr>
                                    <tr class="even">
                                        <!-- 优惠劵金额 -->
                                        <td>优惠券金额</td>
                                        <td>
                                            <span style="color: #f90">{{ order_details.coupon_amount }}</span>
                                        </td>
                                    </tr>
                                    <!-- 代叫费 -->
                                    <tr class="Odd" v-if="order_synchronization.consumer_bear">
                                        <td>{{ order_synchronization.consumer_bear.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.consumer_bear.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 权益类型 -->
                                    <tr class="even">
                                        <td>{{ order_details.equity_type.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_details.equity_type.val }}</span>
                                        </td>
                                    </tr>
                                    <!-- 一口价权益 -->
                                    <tr class="Odd">
                                        <td>{{ order_details.equity_money.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_details.equity_money.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                      <!-- 权益公里数（公里） -->
                                    <tr class="even">
                                        <td>{{ order_details.equity_kilo.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_details.equity_kilo.val }}</span
                                            >公里
                                        </td>
                                    </tr>
                                     <!-- 权益时间（分钟） -->
                                    <tr class="Odd">
                                        <td>{{ order_details.equity_time.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_details.equity_time.val }}</span
                                            >分钟
                                        </td>
                                    </tr>
                                    <!-- 最终权益金额 -->
                                    <tr class="even">
                                        <td>{{ order_details.equity_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_details.equity_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 畅行卡抵扣金额 -->
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.card_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.card_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                   <!-- 等待减免金额 -->
                                    <tr class="even">
                                        <td>{{ order_synchronization.reduction_fee.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.reduction_fee.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                     <!-- 乘客加价 -->
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.dynamic_markup_amount.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.dynamic_markup_amount.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 返程费 -->
                                    <tr class="even">
                                        <td>{{ order_synchronization.return_trip_fee.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.return_trip_fee.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                    <!-- 恶劣天气 -->
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.sleet_fee.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.sleet_fee.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                   <!-- 司机超时减免金额 -->
                                    <tr class="even">
                                        <td>{{ order_synchronization.delay_reduction_fee.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.delay_reduction_fee.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                   <!-- 购买司机加速包金额 -->
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.delay_fee.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.delay_fee.val }}</span
                                            >元
                                        </td>
                                    </tr>
                                </table>

                                <table style="width: 100%" class="primary-table">
                                    <tr class="head">
                                        <td width="240px">行程信息</td>
                                        <td>参数</td>
                                    </tr>
                                    <tr class="Odd" v-if="order_synchronization.driver_go_coordinate_start_name">
                                        <!-- 兼容旧版本数据 -->
                                        <td>{{ order_synchronization.driver_go_coordinate_start_name.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.driver_go_coordinate_start_name.val }}</span>
                                        </td>
                                    </tr>
                                    <tr class="even" v-if="order_synchronization.driver_go_coordinate_end_name">
                                        <!-- 兼容旧版本数据 -->
                                        <td>{{ order_synchronization.driver_go_coordinate_end_name.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.driver_go_coordinate_end_name.val }}</span>
                                        </td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.coordinate_end_name.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.coordinate_end_name.val }}</span>
                                        </td>
                                    </tr>
                                    <tr class="even">
                                        <td>{{ order_synchronization.order_go_coordinate_start_name.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.order_go_coordinate_start_name.val }}</span>
                                        </td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.free_area_distance.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{
                                                Math.round(order_synchronization.free_area_distance.val / 10) / 100
                                            }}</span
                                            >千米
                                        </td>
                                    </tr>

                                    <tr class="even">
                                        <td>{{ order_synchronization.free_area_duration.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{
                                                Math.ceil(order_synchronization.free_area_duration.val / 60)
                                            }}</span
                                            >分
                                        </td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.on_way_distance.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{
                                                Math.round(order_synchronization.on_way_distance.val / 10) / 100
                                            }}</span
                                            >千米
                                        </td>
                                        <!-- <td>
                                            <span style="color: #f90">{{
                                                Math.ceil((order_synchronization.on_way_distance.val / 1000) * 100) / 100
                                            }}</span
                                            >千米
                                        </td> -->
                                    </tr>
                                    <tr class="even">
                                        <td>{{ order_synchronization.on_way_duration.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ Math.ceil(order_synchronization.on_way_duration.val / 60) }}</span
                                            >分
                                        </td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>{{ order_synchronization.wait_duration.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ Math.ceil(order_synchronization.wait_duration.val / 60) }}</span
                                            >分
                                        </td>
                                    </tr>
                                    <tr class="even">
                                        <td>{{ order_synchronization.un_free_area_distance.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{
                                                Math.round(order_synchronization.un_free_area_distance.val / 10) / 100
                                            }}</span
                                            >千米
                                        </td>
                                    </tr>
                                    <tr class="Odd" v-if="order_synchronization.far_area_mode">
                                        <!-- 兼容旧版本数据 -->
                                        <td>{{ order_synchronization.far_area_mode.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{
                                                order_synchronization.far_area_mode.val == 1 ? '激活' : '未激活'
                                            }}</span>
                                        </td>
                                    </tr>
                                    <tr class="even">
                                        <td>{{ order_synchronization.synchro_time.alias }}</td>
                                        <td>
                                            <span style="color: #f90">{{ order_synchronization.synchro_time.val.YmdHis }}</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane label="抢单记录" name="grabbing">
                            <!-- 表格 -->
                            <el-table :data="grabbingData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
                                <el-table-column prop="order_code" label="系统编号">
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="toOrder(scope.row.order_code)">{{ scope.row.order_code }}</el-button>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="time.YmdHis" label="下单时间"> </el-table-column>

                                <el-table-column prop="type.alias" label="说明"> </el-table-column>
                            </el-table>

                            <!-- 分页组件 -->
                            <div style="text-align: right">
                                <el-pagination
                                    layout="prev, pager, next"
                                    :total="result_data_children.count"
                                    @current-change="pages_function"
                                >
                                </el-pagination>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane label="跟踪记录" name="record">
                            <p
                                v-if="order_track_lists.length == 0 || order_track_lists == null"
                                style="font-size: 16px; text-align: center; margin-top: 20px"
                            >
                                暂无跟踪信息
                            </p>

                            <div style="max-height: 100%; overflow-y: auto" v-else>
                                <table style="width: 100%" class="primary-table">
                                    <tr class="head">
                                        <td>时间</td>
                                        <td>备注</td>
                                        <td>端口</td>
                                        <td>管理员</td>
                                    </tr>
                                    <tr
                                        :class="{ Odd: index % 2 != 0, even: index % 2 == 0 }"
                                        v-for="(item, index) in order_track_lists.result"
                                        :key="index"
                                    >
                                        <td>{{ item.time.YmdHis }}</td>
                                        <td>{{ item.remarks }}</td>
                                        <td>{{ item.port.alias }}</td>
                                        <td>{{ item.admin_name }}</td>
                                    </tr>
                                </table>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane label="轨迹列表" name="track">
                            <!-- 兼容旧版本数据 -->
                            <p
                                v-if="
                                    order_synchronization == null ||
                                    order_synchronization == undefined ||
                                    order_synchronization.order_go_coordinate == undefined ||
                                    order_synchronization.order_go_coordinate.val.length == 0
                                "
                                style="font-size: 16px; text-align: center; margin-top: 20px"
                            >
                                暂无轨迹信息
                            </p>

                            <div style="max-height: 100%; overflow-y: auto" v-else>
                                <table style="width: 100%" class="primary-table">
                                    <tr class="head">
                                        <td>定位时间</td>
                                        <td>类型</td>
                                        <td>精度</td>
                                    </tr>
                                    <tr
                                        :class="{ Odd: index % 2 != 0, even: index % 2 == 0 }"
                                        v-for="(item, index) in order_synchronization.order_go_coordinate.val"
                                        @mouseover="tableHover(item.lng, item.lat, item.accuracy, item.time.YmdHis, item.location_type)"
                                        @mouseout="tableLeave"
                                    >
                                        <td>{{ item.time.YmdHis }}</td>
                                        <td>{{ item.location_type }}</td>
                                        <td>{{ item.accuracy }}</td>
                                    </tr>
                                </table>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane label="异常记录" name="difference" v-if="!history">
                            <p
                                v-if="order_difference_lists == null || order_difference_lists.length == 0"
                                style="font-size: 16px; text-align: center; margin-top: 20px"
                            >
                                暂无异常信息
                            </p>

                            <div style="max-height: 100%; overflow-y: auto" v-else>
                                <table style="width: 100%" class="primary-table">
                                    <tr class="head">
                                        <td>订单编号</td>
                                        <td>时间</td>
                                        <td>备注</td>
                                    </tr>
                                    <tr
                                        :class="{ Odd: index % 2 != 0, even: index % 2 == 0 }"
                                        v-for="(item, index) in order_difference_lists.result"
                                    >
                                        <td>{{ item.order_code }}</td>
                                        <td>{{ item.time.YmdHis }}</td>
                                        <td>{{ item.remarks }}</td>
                                    </tr>
                                </table>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane label="隐私通话" name="conversation">
                            <div style="height: 100%; overflow-y: auto">
                                <table style="width: 100%" class="primary-table">
                                    <tr class="head">
                                        <td>通话号</td>
                                        <td>开始时间</td>
                                        <td>结束时间</td>
                                        <td>通话语音</td>
                                    </tr>

                                    <tr class="even" v-for="(item, index) in privateRecord">
                                        <td>{{ item.telx }}</td>
                                        <td>{{ item.startTime }}</td>
                                        <td>{{ item.finishTime }}</td>
                                        <td>
                                            <div style="width: 100%" v-if="item.private_record != ''">
                                                <audio :src="item.private_record" controls>您的浏览器不支持 audio 标签。</audio>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane label="扣费信息" name="deductFee">
                            <div style="height: 100%; overflow-y: auto">
                                <h4 class="deductFee-title">服务费与抽成类</h4>

                                <table style="width: 100%; margin-top: 0" class="deductFee-table">
                                    <tr class="even">
                                        <td>订单金额</td>
                                        <td>{{ deductFee.server_type.orderFee }}元</td>
                                    </tr>

                                    <tr class="Odd">
                                        <td>平台服务费</td>
                                        <td>{{ deductFee.server_type.platformFee }}元</td>
                                    </tr>

                                    <tr class="even">
                                        <td>全职司机抽成</td>
                                        <td>{{ deductFee.server_type.fullDriverFee }}元</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>兼职司机抽成</td>
                                        <td>{{ deductFee.server_type.partDriverFee }}元</td>
                                    </tr>
                                    <tr class="even">
                                        <td>按单司机抽成</td>
                                        <td>{{ deductFee.server_type.singleDriverFee }}元</td>
                                    </tr>

                                    <tr class="Odd">
                                        <td>三方订单抽成</td>
                                        <td>{{ deductFee.server_type.thirdFee }}元</td>
                                    </tr>
                                    <tr class="even">
                                        <td>订单模式抽成</td>
                                        <td>{{ deductFee.server_type.orderModeFee }}元</td>
                                    </tr>
                                </table>

                                <h4 class="deductFee-title">活动类</h4>

                                <table style="width: 100%; margin-top: 0" class="deductFee-table">
                                    <tr class="even">
                                        <td>乘客分享-接单司机承担金额</td>
                                        <td>{{ deductFee.activity_type.consumerShareFee }}元</td>
                                    </tr>

                                    <tr class="Odd">
                                        <td>司机分享-接单司机承担金额</td>
                                        <td>{{ deductFee.activity_type.driverShareFee }}元</td>
                                    </tr>

                                    <tr class="even">
                                        <td>商家分享-接单司机承担金额</td>
                                        <td>{{ deductFee.activity_type.businessShareFee }}元</td>
                                    </tr>
                                </table>

                                <h4 class="deductFee-title">支付类</h4>

                                <table style="width: 100%; margin-top: 0" class="deductFee-table">
                                    <tr class="even">
                                        <td>余额支付-司机承担金额</td>
                                        <td>{{ deductFee.pay_type.balanceFee }}元</td>
                                    </tr>

                                    <tr class="Odd">
                                        <td>畅行卡支付-司机承担金额</td>
                                        <td>{{ deductFee.pay_type.cardFee }}元</td>
                                    </tr>

                                    <tr class="even">
                                        <td>优惠券支付-司机承担金额</td>
                                        <td>{{ deductFee.pay_type.couponFee }}元</td>
                                    </tr>
                                </table>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>

        <!-- 对话框底部按钮 -->
        <div style="display: flex; justify-content: start; height: 32px; margin: 20px 0; padding-left: 20px" v-if="!loading">
            <el-button @click="markAnimation">开始</el-button>
            <el-button @click="resetAnimation">重置</el-button>
            <el-button @click="rulerOpen">测距</el-button>
        </div>
    </el-drawer>
</template>

<script>
import bus from '../../../common/bus.js';
var _this,
    map,
    measureTool,
    marker,
    city_name,
    driverSimulation,
    passedPolyline,
    ruler1,
    temporaryMarker,
    temporaryLabel,
    passedPolyline,
    path,
    polygonPath4,
    leagueMarker,
    polyline,
    polyline1,
    polyline2,
    polyline3;

export default {
    props: {
        isShow: Boolean,
        anjian: '', // 保险中心的案件列表模块和订单监控的订单查看都用当前页面作为详情页面，两个页面传参不一致，所以用当前字段区分
        data: '',
        status: '',
        showConsumer: Boolean,
        history: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            console.log(_this.history, 'history==========');

            _this.$nextTick(function () {
                _this.order_details = [];
                _this.order_synchronization = [];
                _this.order_track_lists = [];

                _this.order_status = _this.status;

                //  没看懂什么意思
                //  data的*数据类型*为什么根据不同引用改变？？？？？？？
                // if (_this.anjian == 'anjian') {
                //     _this.search_data_children.order_code = _this.data.order_code;
                // } else {
                _this.search_data_children.order_code = _this.data;
                // }
            });
        }
    },
    data() {
        return {
            show: false,
            get_car_phone: '',
            wallet_msg: '',
            send_name: '',
            send_phone: '',
            vin_no: '',
            get_name: '',
            get_phone: '',
            assign: '',
            arrive: '',
            driver_img: '',
            menderDay_discountAmount: '', //会员日优惠金额

            loading: true,

            deductFee: {},

            progress_bar: [],
            driver: [],
            // 录音数据
            recording: [],
            privateRecord: [],

            driverMarks_status: [],

            // 骑行路线坐标组
            riding_coordinate: [],

            // 行程坐标点数据
            coordinate_array: [],
            coordinate_array_true: [],

            grabbingData: [],
            appraise_data: [],

            order_status: '',

            order_details: [],

            order_start_img: [],

            order_end_img: [],
            driver_img_pre: [],
            order_synchronization: [],
            order_difference_lists: [],
            order_track_lists: [],
            result_data_children: [],

            stepsNum: 0,

            activeName: 'order',

            order_details_time: {
                order_time: {
                    YmdHis: '未设置'
                },
                assign_time: {
                    YmdHis: '未设置'
                },
                take_time: {
                    YmdHis: '未设置'
                },
                go_way_time: {
                    YmdHis: '未设置'
                },
                arrive_time: {
                    YmdHis: '未设置'
                },
                start_time: {
                    YmdHis: '未设置'
                },
                end_time: {
                    YmdHis: '未设置'
                },
                pay_time: {
                    YmdHis: '未设置'
                }
            },

            search_data_children: {
                order_code: '',
                page: 1,
                limit: 10
            }
        };
    },
    created() {
        _this = this;
    },
    computed: {
         activeNum() {
            let nullIndex = _this.progress_bar.length; // 初始化为数组长度

            for (let i = 0; i < _this.progress_bar.length; i++) {
                if (_this.progress_bar[i].time == '') {
                    nullIndex = i;
                    break; // 找到第一个为空的time后立即跳出循环
                }
            }

            if (nullIndex === _this.progress_bar.length) {
                // console.log('所有time都不为空');
            } else if (nullIndex < _this.progress_bar.length) {
                // console.log('存在time为空');
            } else {
                // console.error('数据异常：nullIndex超出数组范围');
            }

            return nullIndex;
        }
        // activeNum() {
        //     console.log('计算属性');
        //     let nullIndex = 0;

        //     for (let i = 0; i < _this.progress_bar.length; i++) {
        //         console.log(_this.progress_bar[i], 888);
        //         if (_this.progress_bar[i].time == '') {
        //             console.log(1111);
        //             nullIndex = i;
        //             break;
        //         } else {
        //             console.log(222);
        //             nullIndex = _this.progress_bar.length;
        //         }
        //     }

        //     return nullIndex;
        // }
    },

    methods: {
        //翻页组件的回调
        pages_function(val) {
            _this.search_data_children.page = val;

            //初始化列表
            _this.grabbingInit();
        },

        // 订单管理-订单查看:showConsumer="false",历史订单/订单管理/订单指派/活动-司机加速包/九州优惠卡-优惠卡列表/检车线-检车线订单/跑腿-跑腿订单:showConsumer="true",
        grabbingInit() {
            let httpUrl = '';
            // 判断是否请求历史路径
            if (this.history) {
                httpUrl = '/order/orderRobListsHistory';
            } else {
                httpUrl = '/order/orderRobLists';
            }

            _this
                .$post(httpUrl, _this.search_data_children)
                .then((res) => {
                    _this.result_data_children = res;

                    _this.grabbingData = res.data;
                })
                .catch((err) => {});
        },

        // 选项卡点击事件
        handleClick(tab, event) {},

        openDrawer() {
            _this.order_start_img = [];
            _this.order_end_img = [];
            _this.driver_img_pre = [];
            _this.driver_img = '';

            _this.grabbingInit();

            let httpUrl = '';
            // 判断是否请求历史路径
            if (this.history) {
                httpUrl = '/order/getOrderDetailsHistory';
            } else {
                httpUrl = '/order/getOrderDetails';
            }

            _this
                .$post(httpUrl, {
                    order_code: _this.search_data_children.order_code,
                    coordinate: '1',
                    synchronization: '1',
                    order_track: '1',
                    order_difference: '1'
                })
                .then((res) => {
                    // 地图初始化
                    map = new TMap.Map('container_route', {
                        zoom: 11, //初始地图级别
                        viewMode: '2D'
                    });

                    // 创建测量工具
                    measureTool = new TMap.tools.MeasureTool({
                        map: map,
                    });
                    _this.deductFee = res.data.deductFee;
                    _this.progress_bar = res.data.order_details.progress_bar;

                    if (res.data.order_start_img) {
                        // 如果接口返回值则赋值，否则略过，不这样判断会导致loading页面打不开
                        for (let i = 0; i < res.data.order_start_img.length; i++) {
                            if (res.data.order_start_img[i].url != '') {
                                _this.order_start_img.push(res.data.order_start_img[i].url);
                            }
                        }
                    }

                    if (res.data.order_end_img) {
                        // 如果接口返回值则赋值，否则略过，不这样判断会导致loading页面打不开
                        for (let i = 0; i < res.data.order_end_img.length; i++) {
                            if (res.data.order_end_img[i].url != '') {
                                _this.order_end_img.push(res.data.order_end_img[i].url);
                            }
                        }
                    }

                    if (res.data.order_details.driver_img != '') {
                        _this.driver_img_pre.push(res.data.order_details.driver_img);
                    }

                    _this.driver_img = res.data.order_details.driver_img;

                    _this.order_details = res.data.order_details;
                    _this.get_car_phone = res.data.get_car_phone;
                    _this.wallet_msg = res.data.order_details.wallet_msg;
                    _this.send_name = res.data.send_name;
                    _this.send_phone = res.data.send_phone;
                    _this.vin_no = res.data.vin_no;
                    // _this.get_name = res.data.get_name;
                    _this.get_phone = res.data.get_phone;
                    _this.assign = res.data.order_details.assign;
                    _this.arrive = res.data.order_details.arrive;

                    _this.order_synchronization = res.data.order_synchronization;
                    _this.menderDay_discountAmount = res.data.menderDay_discountAmount;

                    _this.recording = res.data.recording;

                    if (
                        _this.order_details.status.val == '2' ||
                        _this.order_details.status.val == '10' ||
                        _this.order_details.status.val == '11' ||
                        _this.order_details.status.val == '15' ||
                        _this.order_details.status.val == '16' ||
                        _this.order_details.status.val == '17' ||
                        _this.order_details.status.val == '18'
                    ) {
                        //  订单为销单状态
                        // 创建起点标记
                        var startMarker = new TMap.MultiMarker({
                            map: map,
                            styles: {
                                "startStyle": new TMap.MarkerStyle({
                                    "width": 25,
                                    "height": 34,
                                    "src": '//mapapi.qq.com/web/lbs/javascriptGL/demo/img/start.png',
                                    "offset": { x: -13, y: -30 },
                                    "zIndex": 999,
                                    "isStopPropagation": true,
                                })
                            },
                            geometries: [{
                                "id": "start_marker",
                                "styleId": "startStyle",
                                "position": new TMap.LatLng(_this.order_details.start_coordinate.lat, _this.order_details.start_coordinate.lng),
                                "draggable": true,
                                "properties": {
                                    "title": "起点"
                                }
                            }]
                        });

                        if (_this.order_details.end_coordinate != null) {
                            // 添加终点标记
                            // 创建一个 Icon
                            var endMarker = new TMap.MultiMarker({
                                map: map,
                                styles: {
                                    "endStyle": new TMap.MarkerStyle({
                                        "width": 25,
                                        "height": 34,
                                        "src": '//mapapi.qq.com/web/lbs/javascriptGL/demo/img/end.png',
                                        "offset": { x: -13, y: -30 },
                                         "zIndex": 999,
                                        "isStopPropagation": true,
                                    })
                                },
                                geometries: [{
                                    "id": "end_marker",
                                    "styleId": "endStyle",
                                    "position": new TMap.LatLng(_this.order_details.end_coordinate.lat, _this.order_details.end_coordinate.lng),
                                    "draggable": true,
                                    "properties": {
                                        "title": "终点"
                                    }
                                }]
                            });

                        }
                    }

                    if (
                        res.data.order_synchronization !== null &&
                        typeof res.data.order_synchronization.order_go_coordinate != 'undefined'
                    ) {
                        _this.coordinate_array = res.data.order_synchronization.order_go_coordinate.val;
                    } else if (res.data.order_synchronization !== null && typeof res.data.order_synchronization.coordinate != 'undefined') {
                        // 兼容旧版本数据

                        _this.coordinate_array = res.data.order_synchronization.coordinate.val;
                    } else {
                        _this.coordinate_array = [];
                    }

                    if (
                        res.data.order_synchronization !== null &&
                        typeof res.data.order_synchronization.driver_go_coordinate !== 'undefined'
                    ) {
                        _this.riding_coordinate = res.data.order_synchronization.driver_go_coordinate.val;
                    } else {
                        _this.riding_coordinate = [];
                    }

                    _this.order_difference_lists =
                        res.data.order_difference_lists !== null && typeof res.data.order_difference_lists !== 'undefined'
                            ? res.data.order_difference_lists
                            : [];

                    _this.order_track_lists =
                        res.data.order_track_lists !== null && typeof res.data.order_track_lists !== 'undefined'
                            ? res.data.order_track_lists
                            : [];

                    if (typeof _this.order_details.pay_time !== 'undefined') {
                        _this.order_details_time.pay_time.YmdHis = _this.order_details.pay_time.YmdHis; // ，司机不可消单
                    }
                    if (typeof _this.order_details.end_time !== 'undefined') {
                        _this.order_details_time.end_time.YmdHis = _this.order_details.end_time.YmdHis; // 到达目的地，司机不可消单
                    }
                    if (typeof _this.order_details.start_time !== 'undefined') {
                        _this.order_details_time.start_time.YmdHis = _this.order_details.start_time.YmdHis; // 前往目的地 ，司机不可消单
                    }
                    if (typeof _this.order_details.arrive_time !== 'undefined') {
                        _this.order_details_time.arrive_time.YmdHis = _this.order_details.arrive_time.YmdHis; // 到达预约地
                    }
                    if (typeof _this.order_details.go_way_time !== 'undefined') {
                        _this.order_details_time.go_way_time.YmdHis = _this.order_details.go_way_time.YmdHis; // 前往预约地
                    }
                    if (typeof _this.order_details.take_time !== 'undefined') {
                        _this.order_details_time.take_time.YmdHis = _this.order_details.take_time.YmdHis; // 已接单
                    }
                    if (typeof _this.order_details.assign_time !== 'undefined') {
                        _this.order_details_time.assign_time.YmdHis = _this.order_details.assign_time.YmdHis; // 已派单
                    }
                    if (typeof _this.order_details.order_time !== 'undefined') {
                        _this.order_details_time.order_time.YmdHis = _this.order_details.order_time.YmdHis; // 新单
                    }

                    if (typeof _this.order_details.pay_time.YmdHis !== 'undefined' && _this.order_details.pay_time.YmdHis !== '未设置') {
                        _this.stepsNum = 8;
                    } else if (
                        typeof _this.order_details.end_time.YmdHis !== 'undefined' &&
                        _this.order_details.end_time.YmdHis !== '未设置'
                    ) {
                        _this.stepsNum = 7;
                    } else if (
                        typeof _this.order_details.start_time.YmdHis !== 'undefined' &&
                        _this.order_details.start_time.YmdHis !== '未设置'
                    ) {
                        _this.stepsNum = 6;
                    } else if (
                        typeof _this.order_details.arrive_time.YmdHis !== 'undefined' &&
                        _this.order_details.arrive_time.YmdHis !== '未设置'
                    ) {
                        _this.stepsNum = 5;
                    } else if (
                        typeof _this.order_details.go_way_time.YmdHis !== 'undefined' &&
                        _this.order_details.go_way_time.YmdHis !== '未设置'
                    ) {
                        _this.stepsNum = 4;
                    } else if (
                        typeof _this.order_details.take_time.YmdHis !== 'undefined' &&
                        _this.order_details.take_time.YmdHis !== '未设置'
                    ) {
                        _this.stepsNum = 3;
                    } else if (
                        typeof _this.order_details.assign_time !== 'undefined' &&
                        typeof _this.order_details.assign_time.YmdHis !== 'undefined' &&
                        _this.order_details.assign_time.YmdHis !== '未设置'
                    ) {
                        _this.stepsNum = 2;
                    } else if (
                        typeof _this.order_details.order_time.YmdHis !== 'undefined' &&
                        _this.order_details.order_time.YmdHis !== '未设置'
                    ) {
                        _this.stepsNum = 1;
                    }

                    var limit_num = 10;
                    if (localStorage.getItem('city_tag') == 'KUNMING') {
                        limit_num = 500;
                    }

                    // 联盟商家坐标
                    _this
                        .$post('/admin.php/Business/ipcShoppingLists', {
                            page: 1,
                            limit: limit_num,
                            shop_name: '',
                            city_code: ''
                        })
                        .then((res) => {
                            if (res.data.length > 0) {
                                for (let i = 0; i < res.data.length; i++) {
                                    leagueMarker = new TMap.MultiMarker({
                                        map: map,  //指定地图容器
                                        //样式定义
                                        styles: {
                                            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                                            "myStyle": new TMap.MarkerStyle({
                                                "width": 25,  // 点标记样式宽度（像素）
                                                "height": 34, // 点标记样式高度（像素）
                                                "src": require('@/assets/League.png'),  //图片路径
                                                "offset": { x: -13, y: -30 }
                                            })
                                        },
                                        //点标记数据数组
                                        geometries: [{
                                            "id": res.data[i].id,   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                                            "styleId": 'myStyle',  //指定样式id
                                            "position": new TMap.LatLng(res.data[i].lat, res.data[i].lng),  //点标记坐标位置
                                            "properties": {//自定义属性
                                                "title": "marker1"
                                            }
                                        }
                                        ]

                                    });
                                }
                            }
                        })
                        .catch((err) => {});

                    // 隐私通话
                    _this
                        .$post('/order/getPrivateRecord', {
                            order_code: _this.search_data_children.order_code
                        })
                        .then((res) => {
                            _this.privateRecord = res.data;
                        })
                        .catch((err) => {});
                    // 将地图绑定点击事件   点击关闭信息窗口
                    map.on('click', this.closePop);

                    // 如果没有行程坐标数据
                    if (
                        _this.order_synchronization == null ||
                        res.data.order_synchronization.driver_go_coordinate.val.length == 0 ||
                        res.data.order_synchronization.order_go_coordinate.val.length == 0
                    ) {
                        var loginCityName = JSON.parse(localStorage.getItem('login')).city.name;

                        var x = loginCityName.indexOf('/');

                        for (var i = 0; i < 1; i++) {
                            x = loginCityName.indexOf('/', x + 1);
                        }

                        // console.log(x);

                        // 如果为市级
                        if (x < 0) {
                            // 截取城市名称 如:XXXX / 截取字段
                            var city_name = loginCityName.slice(loginCityName.indexOf('/') + 2);
                        } else {
                            // 截取城市名称 如:XXXX / XXXX / 截取字段
                            var city_name = loginCityName.slice(x + 2);
                        }

                        console.log(city_name, '------------');

                    }

                    // 请求城市列表接口   获取围栏信息
                     _this.$post('/admin.php/city/getCityDetails', {
                            city_name: city_name
                        })
                        .then((res) => {
                            var center = res.data.center;
                            console.log(center, 'center');
                            const [lng, lat] = center.split(',').map(Number);
                            map.setCenter(new TMap.LatLng(lat, lng));
                            if (JSON.parse(res.data.free_area_coordinate_array) != null && res.data.free_area_coordinate_array != '[]' && res.data.free_area_coordinate_array != '') {
                                let arr = [];
                                var path1 = arr.concat(JSON.parse(res.data.free_area_coordinate_array));
                                path1.push(JSON.parse(res.data.free_area_coordinate_array)[0]);
                                var polygonPath = path1.map(coord => new TMap.LatLng(coord[1], coord[0]));

                            }

                            if (JSON.parse(res.data.far_area_coordinate_array) != null && res.data.far_area_coordinate_array != '[]' && res.data.far_area_coordinate_array != '') {
                                let arr = [];
                                var path2 = arr.concat(JSON.parse(res.data.far_area_coordinate_array));
                                path2.push(JSON.parse(res.data.far_area_coordinate_array)[0]);
                                var polygonPath2 = path2.map(coord => new TMap.LatLng(coord[1], coord[0]));
                            }
                            if (
                                JSON.parse(res.data.effective_area_coordinate_array) != null &&
                                res.data.effective_area_coordinate_array != '[]' &&
                                res.data.effective_area_coordinate_array != ''
                            ) {
                                let arr = [];
                                var path3 = arr.concat(JSON.parse(res.data.effective_area_coordinate_array));
                                path3.push(JSON.parse(res.data.effective_area_coordinate_array)[0]);
                                var polygonPath3 = path3.map(coord => new TMap.LatLng(coord[1], coord[0]));
                            }
                             if (path1) {
                                polyline1 = new TMap.MultiPolyline({
                                    map: map,
                                    //折线样式定义
                                    styles: {
                                        'style_green': new TMap.PolylineStyle({
                                            'color': '#008000', //线填充色
                                            'width': 6, //折线宽度
                                            'lineCap': 'round' //线端头方式
                                        }),
                                    },
                                    //折线数据定义
                                    geometries: [
                                        {//第1条线
                                            'id': 'pl_1',//折线唯一标识，删除时使用
                                            'styleId': 'style_green',//绑定样式名
                                            'paths': polygonPath
                                        }
                                    ],
                                });
                                path1 = [];
                            }

                            if (path2) {
                                polyline2 = new TMap.MultiPolyline({
                                    map: map,
                                    //折线样式定义
                                    styles: {
                                        'style_pink': new TMap.PolylineStyle({
                                            'color': '#FF69B4', //线填充色
                                            'width': 6, //折线宽度
                                            'lineCap': 'round' //线端头方式
                                        }),
                                    },
                                    //折线数据定义
                                    geometries: [
                                        {//第1条线
                                            'id': 'pl_2',//折线唯一标识，删除时使用
                                            'styleId': 'style_pink',//绑定样式名
                                            'paths': polygonPath2
                                        }
                                    ],
                                });
                                path2 = [];
                            }

                            if (path3) {
                                 polyline3 = new TMap.MultiPolyline({
                                    map: map,
                                    //折线样式定义
                                    styles: {
                                        'style_black': new TMap.PolylineStyle({
                                            'color': '#000000', //线填充色
                                            'width': 6, //折线宽度
                                            'lineCap': 'round' //线端头方式
                                        })
                                    },
                                    //折线数据定义
                                    geometries: [
                                        {//第1条线
                                            'id': 'pl_3',//折线唯一标识，删除时使用
                                            'styleId': 'style_black',//绑定样式名
                                            'paths': polygonPath3
                                        }
                                    ],
                                });
                                path3 = [];
                            }
                        })
                        .catch((err) => {});

                    var path_riding = [];

                    if (_this.riding_coordinate.length != 0) {
                        // 如果存在骑行路径
                        for (let index = 0; index < _this.riding_coordinate.length; index++) {
                            path_riding.push(new TMap.LatLng(Number(_this.riding_coordinate[index].lat), Number(_this.riding_coordinate[index].lng)));
                        }
                        console.log(path_riding, 'path_riding');
                        // 骑行路线
                        var ridingPolyline = new TMap.MultiPolyline({
                            map: map,
                            //折线样式定义
                            styles: {
                                'style_green': new TMap.PolylineStyle({
                                    'color': '#FD8B7B', //线填充色
                                    'width': 6, //折线宽度
                                    'borderWidth': 0, //边线宽度
                                    'borderColor': '#ffeeff', //边线颜色
                                    'lineCap': 'round' //线端头方式
                                })
                            },
                            //折线数据定义
                            geometries: [
                                {//第1条线
                                    'id': 'pl_riding',//折线唯一标识，删除时使用
                                    'styleId': 'style_green',//绑定样式名
                                    'paths': path_riding
                                }
                            ],
                        })

                        // var markerContent =
                        //     '' + '<div class="custom-content-marker">' + '   <span class="iconfont icon-zihangche"></span>' + '</div>';

                        // // 将 icon 传入 marker
                        // var ridingStartMarker = new AMap.Marker({
                        //     position: new AMap.LngLat(_this.riding_coordinate[0].lng, _this.riding_coordinate[0].lat),
                        //     content: markerContent,
                        //     offset: new AMap.Pixel(-30, -55)
                        // });

                        // // 将 markers 添加到地图
                        // map.add(ridingStartMarker);
                        var ridingStartMarker = new TMap.MultiMarker({
                            map: map,
                            styles: {
                                "ridingStartStyle": new TMap.MarkerStyle({
                                    "width": 40,
                                    "height": 26,
                                    "src": require('@/assets/car.png'),
                                    "offset": { x: -13, y: -26 }
                                })
                            },
                            geometries: [{
                                "id": "ridingStart_marker",
                                "styleId": "ridingStartStyle",
                                "position": new TMap.LatLng(_this.riding_coordinate[0].lat, _this.riding_coordinate[0].lng),
                                "draggable": true,
                                "properties": {
                                    "title": ""
                                }
                            }]
                        })

                    }

                    var path_coordinate = [];

                    if (_this.coordinate_array.length != 0) {
                        for (let index = 0; index < _this.coordinate_array.length; index++) {
                            path_coordinate.push([_this.coordinate_array[index].lng, _this.coordinate_array[index].lat]);
                            polygonPath4 = path_coordinate.map(coord => new TMap.LatLng(coord[1], coord[0]));
                        }

                        _this.coordinate_array_true = path_coordinate;

                        polyline = new TMap.MultiPolyline({
                            map: map,
                            //折线样式定义
                            styles: {
                                'style_blue': new TMap.PolylineStyle({
                                    'color': '#409EFF', //线填充色
                                    'width': 6, //折线宽度
                                    'borderWidth': 0, //边线宽度
                                    'borderColor': '#ffeeff', //边线颜色
                                    'lineCap': 'round' //线端头方式
                                })
                            },
                            //折线数据定义
                            geometries: [
                                {//第1条线
                                    'id': 'pl_riding',//折线唯一标识，删除时使用
                                    'styleId': 'style_blue',//绑定样式名
                                    'paths': polygonPath4
                                }
                            ],
                        })


                        // 如果存在骑行路径,才会有ridingPolyline缩放地图到合适的视野级别，以骑行轨迹和路程轨迹为中心点进行缩放
                        if (_this.riding_coordinate.length != 0) {
                            // map.setFitView([ridingPolyline, polyline], true, [50, 50, 50, 50], 15);
                        }

                        // 创建起点标记
                        startMarker = new TMap.MultiMarker({
                            map: map,
                            styles: {
                                "startStyle": new TMap.MarkerStyle({
                                    "width": 25,
                                    "height": 34,
                                    "src": '//mapapi.qq.com/web/lbs/javascriptGL/demo/img/start.png',
                                    "offset": { x: -13, y: -30 },
                                    "zIndex": 999,
                                    "isStopPropagation": true,
                                })
                            },
                            geometries: [{
                                "id": "start_marker",
                                "styleId": "startStyle",
                                "position": new TMap.LatLng( _this.coordinate_array[0].lat,  _this.coordinate_array[0].lng),
                                "draggable": true,
                                "properties": {
                                    "title": "起点"
                                }
                            }]
                        });

                        // 添加终点标记
                        endMarker = new TMap.MultiMarker({
                            map: map,
                            styles: {
                                "endStyle": new TMap.MarkerStyle({
                                    "width": 25,
                                    "height": 34,
                                    "src": '//mapapi.qq.com/web/lbs/javascriptGL/demo/img/end.png',
                                    "offset": { x: -13, y: -30 },
                                    "zIndex": 999,
                                    "isStopPropagation": true,
                                })
                            },
                            geometries: [{
                                "id": "end_marker",
                                "styleId": "endStyle",
                                "position": new TMap.LatLng( _this.coordinate_array[_this.coordinate_array.length - 1].lat, _this.coordinate_array[_this.coordinate_array.length - 1].lng),
                                "draggable": true,
                                "properties": {
                                    "title": "终点"
                                }
                            }]
                        })
                        // AMap.plugin('AMap.MoveAnimation', function(){
                        //     // 模拟的司机标记
                        //     driverSimulation = new AMap.Marker({
                        //         map: map,
                        //         position: [Number(_this.coordinate_array[0].lng), Number(_this.coordinate_array[0].lat)],
                        //         icon: "https://a.amap.com/jsapi_demos/static/demo-center-v2/car.png",
                        //         offset: new AMap.Pixel(-13, -26),
                        //         bubble: true
                        //     });
                        // });
                        // // 模拟的行程路线
                        // passedPolyline = new AMap.Polyline({
                        //     map: map,
                        //     // path: lineArr,
                        //     strokeColor: '#AF5', //线颜色
                        //     // strokeOpacity: 1,     //线透明度
                        //     strokeWeight: 6, //线宽
                        //     // strokeStyle: "solid"  //线样式
                        //     bubble: true
                        // });

                        //创建mareker（小车）
                        driverSimulation = new TMap.MultiMarker({
                            map,
                            styles: { //样式设置
                                'car-down': new TMap.MarkerStyle({
                                // 'anchor': {   //图片中心的像素位置（小车会保持车头朝前，会以中心位置进行转向）
                                //     x: 20,y: 20,
                                // },
                                'width': 26,
                                'height': 52,
                                'faceTo': 'map',  //取’map’让小车贴于地面，faceTo取值说明请见下文图示
                                'rotate': 180,    //初始小车朝向（正北0度，逆时针一周为360度，180为正南）
                                'src': 'https://a.amap.com/jsapi_demos/static/demo-center-v2/car.png',   //小车图片（图中小车车头向上，即正北0度）
                                })
                            },
                            geometries: [{    //小车marker的位置信息
                                id: 'car',      //因MultiMarker支持包含多个点标记，因此要给小车一个id
                                styleId: 'car-down',    //绑定样式
                                position: new TMap.LatLng(Number(_this.coordinate_array[0].lat), Number(_this.coordinate_array[0].lng)),//初始坐标位置
                            }]
                        });
                    }

                    _this.$nextTick(function () {
                        _this.loading = false;
                    });

                    // 测距功能
                    // AMap.plugin(['AMap.RangingTool'], function () {
                    //     ruler1 = new AMap.RangingTool(map);
                    // });
                })
                .catch((res) => {});
        },

        // 计算订单时长方法
        getTimes(startTime, endTime) {
            if (startTime === '未设置') {
                return startTime;
            }

            if (endTime === '未设置') {
                return endTime;
            }
            let startTime1 = startTime.replace(/\-/g, '/');
            let endTime1 = endTime.replace(/\-/g, '/');

            let date1 = new Date(startTime1); //开始时间
            let date2 = new Date(endTime1); //结束时间
            let date3 = date1.getTime() - date2.getTime(); //时间差秒

            let hours = Math.floor(date3 / (3600 * 1000));

            //计算相差分钟数
            let leave1 = date3 % (3600 * 1000); //计算小时数后剩余的毫秒数
            let minutes = Math.floor(leave1 / (60 * 1000));

            //计算相差秒数
            let leave2 = leave1 % (60 * 1000); //计算分钟数后剩余的毫秒数
            let seconds = Math.round(leave2 / 1000);

            let string = hours + '时' + minutes + '分' + seconds + '秒';

            return string;
        },

        tableHover(lng, lat, accuracy, time, type) {
            _this.tableLeave();

            temporaryMarker = new TMap.MultiMarker({
                map: map,
                styles: {
                    "temporaryStyle": new TMap.MarkerStyle({
                        "width": 25,
                        "height": 34,
                        "src": '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                        "offset": { x: -13, y: -30 },
                        "zIndex": 999,
                        "isStopPropagation": true,
                    })
                },
                geometries: [{
                    "id": "temporary_marker",
                    "styleId": "temporaryStyle",
                    "position": new TMap.LatLng(Number(lat), Number(lng)),
                    "draggable": true,
                    "properties": {
                        "title": "临时点"
                    }
                }]
            });

            if (lng == undefined) {
                lng = '';
            }
            if (lat == undefined) {
                lat = '';
            }
            if (time == undefined) {
                time = '';
            }
            if (type == undefined) {
                type = '';
            }
            if (accuracy == undefined) {
                accuracy = '';
            }

            temporaryLabel = new TMap.InfoWindow({
                map: map,
                position: new TMap.LatLng(Number(lat), Number(lng)),
                content:
                    '<div style="width: 200px;">' +
                    '<h5 style="padding: 5px 0;text-align: center;background-color: #409EFF; color:#fff">轨迹详情</h5>' +
                    '<div style="padding: 5px;background-color: #fff;">' +
                    '<p>经度:' +
                    lng +
                    '</p>' +
                    '<p>纬度:' +
                    lat +
                    '</p>' +
                    '<p>定位时间:' +
                    time +
                    '</p>' +
                    '<p>类型:' +
                    type +
                    '</p>' +
                    '<p>精度:' +
                    accuracy +
                    '</p>' +
                    '</div>' +
                    '</div>',
                offset: { x: 0, y: -30 },
            });
        },

        tableLeave() {
            if (temporaryMarker) {
                // temporaryMarker.setMap(null);
                temporaryMarker.setGeometries([]);
            }

            if (temporaryLabel) {
                temporaryLabel.close();
            }
        },

        // 测距按钮
        rulerOpen() {
            measureTool.measureDistance().then((res) => {
                //测量结束，将结果显示到页中
                // alert('测量结果为：' + res.totalDistance + '米');
            });
        },

        // 开始按钮
        markAnimation() {
            if (passedPolyline) {
                passedPolyline.remove('pl_passed')
            }
            path = [];

            if (_this.coordinate_array_true.length != 0) {
            for (let index = 0; index < _this.coordinate_array_true.length; index++) {


                let lng = _this.coordinate_array_true[index][0];
                let lat = _this.coordinate_array_true[index][1];
                path.push(new TMap.LatLng(Number(lat), Number(lng)));

            }

            }
            console.log(path, 'path');
            // 车已走过的线
            passedPolyline = new TMap.MultiPolyline({
                map,
                styles: { //样式设置
                    'car-down': new TMap.PolylineStyle({
                        color: '#AF5', //线颜色
                        width: 6, //线宽
                        isStopPropagation: true
                    })
                },
                geometries: [{
                    id: 'pl_passed',
                    style: 'car-down',
                    paths: path
                }]
            });


            driverSimulation.moveAlong(
                {
                    car: {
                        path: path,
                        speed: 500,
                    },
                },
                {
                    autoRotation: true,
                }
            );

            driverSimulation.on('moving', function (e) {

                var passedLatLngs = e.car && e.car.passedLatLngs;
                if (passedLatLngs) {
                // 使用路线擦除接口 eraseTo, https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocVector
                passedPolyline.eraseTo(
                    'pl_passed',
                    passedLatLngs.length - 1,
                    passedLatLngs[passedLatLngs.length - 1]
                );
                }

            });

            // driverSimulation.moveAlong(path, 500);
        },

        // 重置按钮
        resetAnimation() {
            driverSimulation.resumeMove();

            // 清除车已走过的线
            if (passedPolyline) {
                passedPolyline.remove('pl_passed');
            }

            // driverSimulation.moveAlong(path, 500);
            driverSimulation.stopMove();
            driverSimulation.setGeometries([
              {
                id: 'car',      //因MultiMarker支持包含多个点标记，因此要给小车一个id
                styleId: 'car-down',    //绑定样式
                position: new TMap.LatLng(Number(_this.coordinate_array[0].lat), Number(_this.coordinate_array[0].lng)),//初始坐标位置
              }
            ]);
        },

        // 管理司机信息窗口方法
        closePop() {
            // 遍历关闭信息窗口
            for (const key in _this.driverMarks_status) {
                _this.driverMarks_status[key].close();
            }
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;

            _this.$nextTick(function () {
                _this.get_car_phone = '';
                _this.wallet_msg = '';
                _this.send_name = '';
                _this.send_phone = '';
                _this.vin_no = '';
                _this.get_name = '';
                _this.get_phone = '';
                _this.assign = '';
                _this.arrive = '';
                _this.driver_img = '';
                _this.menderDay_discountAmount = ''; //会员日优惠金额

                _this.loading = true;

                _this.deductFee = {};

                _this.progress_bar = [];
                _this.driver = [];
                // 录音数据
                _this.recording = [];
                _this.privateRecord = [];

                _this.driverMarks_status = [];

                // 骑行路线坐标组
                _this.riding_coordinate = [];

                // 行程坐标点数据
                _this.coordinate_array = [];
                _this.coordinate_array_true = [];

                _this.grabbingData = [];
                _this.appraise_data = [];

                _this.order_status = '';

                _this.order_details = [];

                _this.order_start_img = [];

                _this.order_end_img = [];
                _this.driver_img_pre = [];
                _this.order_synchronization = [];
                _this.order_difference_lists = [];
                _this.order_track_lists = [];
                _this.result_data_children = [];

                _this.stepsNum = 0;

                _this.activeName = 'order';

                _this.order_details_time = {
                    order_time: {
                        YmdHis: '未设置'
                    },
                    assign_time: {
                        YmdHis: '未设置'
                    },
                    take_time: {
                        YmdHis: '未设置'
                    },
                    go_way_time: {
                        YmdHis: '未设置'
                    },
                    arrive_time: {
                        YmdHis: '未设置'
                    },
                    start_time: {
                        YmdHis: '未设置'
                    },
                    end_time: {
                        YmdHis: '未设置'
                    },
                    pay_time: {
                        YmdHis: '未设置'
                    }
                };

                _this.search_data_children = {
                    order_code: '',
                    page: 1,
                    limit: 10
                };

                map && map.destroy();
            });
        }
    }
};
</script>

<style scoped>
/* 高德地图css */
@import 'https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css';
@import 'https://a.amap.com/jsapi_demos/static/demo-center/css/prety-json.css';

#container_route {
    height: 137px;
    height: 100%;
    width: 50%;
    background-image: url();
}

.steps {
    box-sizing: border-box;
    padding: 20px 50px 0;
    box-sizing: border-box;
    font-size: 12px;
    margin-bottom: 20px;
}

.box {
    height: calc(100vh - 350px);
    margin-left: 20px;
    display: flex;
    justify-content: space-around;
}

.tabs-item {
    margin-top: 20px;
}

.tabs-item div {
    margin: 20px 0;
}

.tabs-item div span {
    font-size: 16px;
    font-weight: 400;
}

.tabs-box {
    width: 50%;
    padding: 0 16px;
    height: calc(100vh - 350px);
}
</style>
<style>
.iconfont.icon-zihangche {
    font-size: 60px !important;
}

.iconfont.icon-zihangche::before {
    color: #00b9da !important;
}

.tabs-box .tabs {
    height: 100%;
}

.tabs-box .el-tabs__content {
    height: 90%;
    overflow: auto;
}

.order-detial-wrap #el-drawer__title > span {
    font-size: 18px;
    font-family: 'Microsoft YaHei';
    font-weight: 600;
    color: #222;
    line-height: 21px;
}

.order-detial-wrap .el-tabs--card > .el-tabs__header {
    border-bottom: 1px solid #e4e7ed !important;
}

.order-detial-wrap .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #fff !important;
    border-left: 1px solid rgb(228, 231, 237) !important;
    border-right: 1px solid rgb(228, 231, 237) !important;
    border-top: 1px solid rgb(228, 231, 237) !important;
}

.order-detial-wrap .el-tabs--card > .el-tabs__header .el-tabs__item {
    border-bottom: 1px solid transparent;
}

.primary-table {
    margin-top: 40px;
    padding: 10px;
}

.primary-table,
.primary-table th,
.primary-table td {
    border: none;
}

.primary-table tr {
    border: 1px solid #ccc;
    transition: 0.5s;
}

.primary-table td {
    font-size: 12px;
    color: #333;
    padding: 10px;
}

.even td,
.Odd td {
    font-size: 14px;
    font-weight: 400;
}

.even {
    /* background-color: #f5f7fa; */
}
.view-nth tr:nth-child(even) {
    /* 表格隔行变色 */
    background-color: #f5f7fa !important;
}

.head {
    background-color: #eff2f7;
}

.primary-table tr:hover {
    background-color: #b4d2f4;
}

.deductFee-title {
    font-size: 20px;
    font-weight: bold;
}

.deductFee-table,
.deductFee-table th,
.deductFee-table td {
    border: none;
}

.deductFee-table tr {
    border: 1px solid #ccc;
    transition: 0.5s;
}

.deductFee-table td {
    font-size: 12px;
    color: #333;
    padding: 10px;
}

.deductFee-table tr td:first-of-type {
    width: 80%;
}
</style>
